<div class="session-ended-dialog">
  <div class="dialog-content">
    <div class="illustration-wrap">
      <img [src]="illustration" alt="Session ended illustration" class="illustration" />
    </div>

    <div class="text-content">
      <h2 class="title">{{ title }}</h2>
      <p class="description">{{ description }}</p>
    </div>

    <div class="button-wrap">
      <lib-button (click)="onLoginAgain()" [label]="'Log In Again'" type="Primary" width="120px">
      </lib-button>
    </div>
  </div>
</div>
